module.exports = __webpack_public_path__ + "img/5.46387492.jpg";